import React from "react"
import { Input, Button, Flex, Form } from "antd"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"
import { useDispatch, useSelector } from "react-redux"
import { updatePaymentMethodExpiry } from "store/user"
import { Modal } from "ui/Modal"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { validateExpiryDate } from "helpers/card"
import { toaster } from "components/common/Toast"

const EditCardExpiryDate = ({ isOpen, onClose, selectedCard }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { loading } = useSelector((state) => state.user?.updatePaymentMethodExpiry)

  const month = selectedCard?.exp_month
  const year = selectedCard?.exp_year
  const initialMMYY = month && year ? `${String(month).padStart(2, "0")}/${String(year).slice(-2)}` : ""

  // Auto-format expiry date input
  const handleExpiryChange = (e) => {
    const rawValue = e.target.value
    let value = rawValue.replaceAll(/\D/g, "") // Remove non-digits

    // Format based on number of digits
    if (value.length > 2) {
      // More than 2 digits: format as MM/YY
      value = value.slice(0, 2) + "/" + value.slice(2, 4)
    } else if (value.length === 2 && !rawValue.endsWith("/")) {
      // Exactly 2 digits and raw input doesn't have slash yet: add it
      // This makes "12" become "12/" but prevents "12/" from staying stuck
      value = value + "/"
    }

    form.setFieldsValue({ expiry: value })
  }

  const handleFinish = (values) => {
    const expiry = values.expiry
    if (/^\d{2}\/\d{2}$/.test(expiry) && selectedCard?.id) {
      dispatch(
        updatePaymentMethodExpiry({
          payment_method_id: Number(selectedCard.id),
          expiry_date: expiry
        })
      ).then((response) => {
        if (response?.message) {
          toaster.success(response.message)
        }
        onClose()
      })
    }
  }

  // Prepare masked card number for display
  const maskedCardNumber = selectedCard ? `****${selectedCard.last4}` : ""

  return (
    <Modal open={isOpen} onCancel={onClose} centered title={t("trip.card.edit_card_details")} width={600}>
      <Form form={form} layout="vertical" initialValues={{ expiry: initialMMYY, cardNumber: maskedCardNumber }} onFinish={handleFinish}>
        <LabeledField labelKey={t("trip.card.card_number")} name="cardNumber">
          <Input disabled />
        </LabeledField>
        <LabeledField
          labelKey={t("trip.card.expiration_date")}
          name="expiry"
          rules={[
            { required: true, message: "" },
            {
              validator: (_, value) => {
                return validateExpiryDate({ value, t })
              }
            }
          ]}
        >
          <Input placeholder="MM/YY" maxLength={5} onChange={handleExpiryChange} />
        </LabeledField>
        <Flex gap={8} justify="end">
          <Button onClick={onClose} style={{ minWidth: 100 }} disabled={loading}>
            {t("global.cancel")}
          </Button>
          <Button type="primary" htmlType="submit" style={{ minWidth: 100 }} loading={loading} disabled={loading}>
            {t("global.save")}
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}

EditCardExpiryDate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedCard: PropTypes.object
}

export default EditCardExpiryDate
